import FormController from '@controllers/portal/components/form_controller';

export default class extends FormController {
  connect() { /** */ }
}
